var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="panel '+
((__t=( panelClasses ))==null?'':_.escape(__t))+
'">\n  <div class="panel-heading '+
((__t=( headingClasses ))==null?'':_.escape(__t))+
'" data-mount="heading">\n    <h3 class="panel-title"></h3>\n    <div class="panel-sub-title"></div>\n    <div class="panel-actions '+
((__t=( actionsClasses ))==null?'':_.escape(__t))+
'" data-mount="actions"></div>\n  </div>\n  <div class="panel-content '+
((__t=( bodyClasses ))==null?'':_.escape(__t))+
'" data-body-for="'+
((__t=( title ))==null?'':_.escape(__t))+
'">\n    <div class="panel-body" data-mount="body"></div>\n    <div class="panel-footer" data-mount="footer"></div>\n  </div>\n</div>\n';
}
return __p;
};
